// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"hu-z","tooltipWrapper":"iu-z","icon":"ju-z","tooltip":"ku-z","content":"lu-z"};